var exports = {
  "kL": "FormSwitch.module__container___R3FVR3",
  "oE": "FormSwitch.module__compact___R3FVR3",
  "_A": "FormSwitch.module__labelContainer___R3FVR3",
  "Pf": "FormSwitch.module__label___R3FVR3",
  "r9": "FormSwitch.module__disabled___R3FVR3",
  "vk": "FormSwitch.module__clickable___R3FVR3",
  "h_": "FormSwitch.module__description___R3FVR3",
  "HV": "FormSwitch.module__switchRoot___R3FVR3",
  "L8": "FormSwitch.module__switchThumb___R3FVR3",
  "nL": "FormSwitch.module__iconChecked___R3FVR3",
  "ao": "FormSwitch.module__iconUnchecked___R3FVR3",
};

module.exports = exports;
